import { fetchGroup } from '../api/gas';
const getUserEligibility = async (logger) => {
    try {
        const response = await fetchGroup(`eligibility/owner`, {}, logger);
        if (response.status === 200) {
            return true;
        }
        return false;
    }
    catch (error) {
        return false;
    }
};
export default getUserEligibility;
